import { render } from "./BaseEmailInput.vue?vue&type=template&id=6c5d0944&ts=true"
import script from "./BaseEmailInput.vue?vue&type=script&lang=ts"
export * from "./BaseEmailInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__